// import React, { useState, useEffect } from "react";
import "./index.css";
import Approutes from "./Routes/Approutes";
import CursorFollower from "./Components/Shared/CursorFollower.";
// import WelcomeModal from "./Components/Layout/WelcomeModal";
const App = () => {
  // const MODAL_INTERVAL_HOURS = 6; // change to 1 if needed
  // const [open, setOpen] = useState(false);

  // useEffect(() => {
  //   const lastShown = localStorage.getItem("welcomeModalTime");
  //   const now = Date.now();

  //   const interval = MODAL_INTERVAL_HOURS * 60 * 60 * 1000; // hours → ms

  //   if (!lastShown || now - Number(lastShown) > interval) {
  //     setOpen(true);
  //     localStorage.setItem("welcomeModalTime", now.toString());
  //   }
  // }, []);
  return (
    <>
      {/* <Header /> */}
      {/* <WelcomeModal open={open} onClose={() => setOpen(false)} /> */}
      <CursorFollower />
      <Approutes />
    </>
  );
};

export default App;
